class NewAccordion extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      description: '.accordion-description',
      mobileOnly: 'accordion-item--mobile-only',
      active: 'h-auto'
    };
  }

  connectedCallback() {
    this.items = this.querySelectorAll('.accordion-item');
    this.items.forEach(item => {
      item.querySelector('.accordion-header').addEventListener('click', (event) => this.accordionOpen(event));
    });
  }

  accordionOpen(event) {
    const currentItem = event.currentTarget.parentNode;
    const description = currentItem.querySelector(this.selectors.description);
    const descriptionHeight = description.scrollHeight;

    if (event.target.tagName.toLowerCase() === 'a' || event.currentTarget.parentNode.classList.contains(this.selectors.mobileOnly) && window.innerWidth >= 769) {
      return;
    }

    if (currentItem.classList.contains(this.selectors.active)) {
      this.removeActive();
      description.style.height = `${descriptionHeight}px`;
      setTimeout(() => {description.style.height = 0}, 100);
    } else {
      this.removeActive();
      currentItem.classList.add(this.selectors.active);
      description.style.height = `${descriptionHeight}px`;
      setTimeout(() => {description.style.height = 'auto'}, 300);
      if (currentItem.querySelector('.vertical.vertical--plus')) {
        currentItem.querySelector('.vertical.vertical--plus').style.transform = 'translate(-50%, -50%) rotate(90deg)';
      } else {
        currentItem.querySelector('.vertical').style.transform = 'translate(-50%, -50%) rotate(180deg)';
      }
    }
  }

  removeActive() {
    this.items.forEach(item => {
      const accordion = item;
      accordion.classList.remove(this.selectors.active);
      accordion.querySelector('.vertical').style.transform = 'translate(-50%, -50%) rotate(0deg)';
      accordion.querySelector(this.selectors.description).style.height = 0;
    });
  }
}

customElements.define('new-accordion', NewAccordion);
